import getGlobal from './getGlobal';

/**
 * 获取cookie中指定字段值
 * @param cookie 值
 * @param cookieName 想要获取的字段key 
 * @returns 
 */
function getCookieValue(cookie: string, cookieName: string): string {

    const pattern = new RegExp(cookieName + '=([^;]+)');
    const match = cookie.match(pattern);
    return match ? match[1] : '';

}

/**
 * 通过cookies获取当前的语言，如果cookie中未设置则默认英语
 * @returns 
 */
function getCurrentLangByCookie(): string {
    if (!getGlobal()?.document) {
        return 'en';
    }
    const lang = getCookieValue(document.cookie, 'REO_LANGUAGE');
    return lang ? lang : 'en';
}

export default getCurrentLangByCookie;
